import React from "react";
import { Layout } from "antd";
import Slide from "../../utils/images/groomsmen-main.jpg";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";

function Banner() {
  return (
    <>
      <Layout>
        <div style={styles.banner}>
          <h3 style={styles.title}>BEST MAN</h3>
          <HeartStyle>
            <span className="white-line"></span>
            <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
            <HeartFilled
              style={{
                fontSize: 19,
                marginLeft: -5,
                color: "white",
              }}
            />
            <span className="white-line"></span>
          </HeartStyle>
          <span style={styles.text}>
            Lorem ipsum dolor adipiscing elit. Integer <br /> ultrices malesuada
            ante quis pharetra. Nullam <br /> non bibendum dolor. Ut vel turpis
            accumsan, efficitur
          </span>
        </div>
      </Layout>
    </>
  );
}
const styles = {
  banner: {
    background: `linear-gradient(10deg,rgba(15,210,210,0.5),rgba(200,70,210,0.5)),url(${Slide})`,
    height: 470,
    backgroundSize: "cover",
    padding: 40,

    backgroundPosition: "center",
    // backgroundAttachment: "fixed",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    textAlign: "center",
    marginBottom: 20,
  },
  text: {
    fontSize: 16,
    fontWeight: 500,
    // transform: "rotate(-10deg)",
    marginBottom: 24,
    // width: "50%",
    color: "white",
    fontFamily: "sans-serif ",
    textAlign: "center",
  },
  title: {
    letterSpacing: 3,
    fontSize: 40,
    fontWeight: 700,
    color: "white",
    marginBottom: 24,
    fontFamily: "sans-serif ",
    textAlign: "center",
  },
};

export default Banner;
